import type { Currency } from '@/types/domain'

export type RateAgainstUsdSource = 'identity' | 'boc'

export interface RateAgainstUsdResult {
  /** Multiplier to convert FROM the adapter's currency TO USD. */
  rate: number
  /** ISO date of the publication actually used (may regress per D-04). */
  effectiveDate: string
  /** Where the rate came from. `identity` for the USD trivial adapter. */
  source: RateAgainstUsdSource
}

export type AdapterErrorCode =
  | 'NETWORK'
  | 'TIMEOUT'
  | 'HTTP_4XX'
  | 'HTTP_5XX'
  | 'RATE_LIMITED'
  | 'ABORTED'
  | 'PARSE'
  | 'SEM_PUBLICACAO_NO_INTERVALO'

export class AdapterError extends Error {
  readonly code: AdapterErrorCode
  override readonly cause: unknown

  constructor(code: AdapterErrorCode, message: string, cause?: unknown) {
    super(message)
    this.name = 'AdapterError'
    this.code = code
    this.cause = cause
  }
}

export interface CurrencyAdapter {
  readonly code: Currency
  /**
   * Returns the conversion rate from this currency to USD on `receiptDateIso`.
   * If the source publishes no rate on that exact date, regresses to the most
   * recent prior business day and surfaces the effective date back.
   *
   * Throws `AdapterError` on transport or contract failures.
   */
  rateAgainstUSD(receiptDateIso: string): Promise<RateAgainstUsdResult>
}
